export const NAV_ITEMS = [
    { label: 'Home', path: '/' },
    { label: 'Upcoming Litters', path: '/upcoming-litters' },
    { label: 'Puppy Application', path: '/puppy-application' },
    { label: 'Our Poodles', path: '/our-poodles' },
] as const;

export const EXPLORE_ITEMS = [
    { label: 'Health & History', path: '/health-history' },
    { label: 'Grooming', path: '/grooming' },
    { label: 'About Us', path: '/about-us' },
] as const;

export const FOOTER_BREEDING_LABEL = 'Breeding';

export const EXPLORE_MENU_LABEL = 'Explore';

export const FOOTER_BREEDING_ITEMS = NAV_ITEMS.filter((item) => item.path !== '/');

export const FOOTER_MOBILE_ITEMS = [
    { label: 'Upcoming Litters', path: '/upcoming-litters' },
    { label: 'Puppy Application', path: '/puppy-application' },
] as const;

export const isExplorePath = (path: string): boolean =>
    EXPLORE_ITEMS.some((item) => item.path === path);

export const getTabIndexFromPath = (path: string): number => {
    const index = NAV_ITEMS.findIndex((item) => item.path === path);
    return index === -1 ? 0 : index;
};
